// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + "icon-library" + "." + "4506e8a2" + ".js";
};